import {
  Datagrid,
  DateField,
  List,
  NumberField,
  ReferenceField,
  TextField,
  FunctionField
} from 'react-admin';
import ListPagination from '../../components/ListPagination';
import isUserRetailer from '../../lib/isUserRetailer';
import getRetailerId from '../../lib/getRetailerId';

const PartnerPaymentList = props => {
  // Retailers veem apenas seus pagamentos
  const filter = isUserRetailer() ? { retailerId: getRetailerId() } : {};

  return (
    <List
      {...props}
      resource="partner-payments"
      title={isUserRetailer() ? "Pagamentos" : "Pagamentos de Parceiros"}
      perPage={25}
      pagination={<ListPagination />}
      sort={{ field: 'createdAt', order: 'DESC' }}
      filter={filter}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <DateField
          source="paymentDate"
          label="Data do Pagamento"
          showTime
          locales="pt-BR"
        />
        <ReferenceField
          source="createdBy"
          reference="employees"
          label="Criado por"
          link={false}
        >
          <TextField source="name" />
        </ReferenceField>
        <NumberField
          source="totalValue"
          label="Valor Total"
          textAlign="center"
          options={{
            style: 'currency',
            currency: 'BRL',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }}
        />
        <FunctionField
          label="Qtd. Cobranças"
          render={record => record.clientBillsCount || 0}
          textAlign="center"
        />
        <TextField source="observation" label="Observação" emptyText="-" />
      </Datagrid>
    </List>
  );
};

export default PartnerPaymentList;
